/**
 * User profile API service
 */

import apiClient from './api';
import { User } from './authService';

export const userService = {
  /**
   * Fetch the currently authenticated user's profile
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<User>('/api/users/me');
    return response.data;
  },

  /**
   * Update the currently authenticated user's display name
   */
  async updateProfile(displayName: string): Promise<User> {
    const response = await apiClient.patch<User>('/api/users/me', {
      display_name: displayName,
    });
    return response.data;
  },
};

export default userService;
